import type { ComponentProps, ReactNode } from 'react';
import { cn } from '../lib/cn.ts';

export type OverlineTone = 'brand' | 'muted';

export interface OverlineProps extends ComponentProps<'p'> {
  tone?: OverlineTone;
  children?: ReactNode;
}

/**
 * The little line above a title — "1 ТОВАР", "БРЕНД".
 *
 * Mono, upper case and tracked out, which is the product's one use of the mono
 * face outside code: it separates a label from the content it labels without
 * spending a heading on it.
 */
export function Overline({ tone = 'muted', className, ...props }: OverlineProps) {
  return (
    <p
      className={cn(
        // Sans, not mono. The product defines a mono stack and then applies
        // it nowhere — reaching for it here was an invention, and a
        // typewriter face in a coral count is the sort of thing that reads as
        // "someone else's design system" without anyone being able to say why.
        'uppercase',
        tone === 'brand'
          ? // A count: 12px, regular, and its own coral.
            'text-2xs font-normal tracking-[0.05em] text-brand-count'
          : // A section label: smaller, bolder, wider, quieter.
            'text-3xs font-bold tracking-[0.11em] text-ink-faint',
        className,
      )}
      {...props}
    />
  );
}
